import { atom } from "jotai";

export const openMenu = atom(true);
